<template>
  <div>
    <div class="flex flex-col max-w-xl mx-auto my-10">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="flex flex-col">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
          >
            <NotificationPreview
              v-if="reminderConfig.metadata"
              :title="reminderConfig.metadata.title"
              :description="reminderConfig.metadata.description"
            />
            <div class="overflow-hidden rounded-md bg-white px-6 py-4 shadow">
              <form @submit="handleSubmit" v-if="reminderConfig.metadata">
                <div class="space-y-12">
                  <div class="pb-12">
                    <h2 class="text-base font-semibold leading-7 text-gray-900">
                      Reminder - {{ $route.params.index + 1 }}
                    </h2>

                    <div
                      class=" grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6"
                    >
                      <div class="sm:col-span-6">
                        <label
                          class="block text-sm font-medium leading-6 text-gray-900"
                          >Title</label
                        >
                        <div class="mt-2">
                          <input
                            type="text"
                            v-model="reminderConfig.metadata.title"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2"
                          />
                        </div>
                      </div>
                      <div class="sm:col-span-6">
                        <label
                          class="block text-sm font-medium leading-6 text-gray-900"
                          >Description</label
                        >
                        <div class="mt-2">
                          <textarea
                            id="about"
                            name="about"
                            v-model="reminderConfig.metadata.description"
                            rows="3"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2"
                          ></textarea>
                        </div>
                      </div>
                      <div class="sm:col-span-6">
                        <label
                          class="block text-sm font-medium leading-6 text-gray-900"
                          >Redirect Link</label
                        >
                        <div class="mt-2">
                          <input
                            type="text"
                            v-model="reminderConfig.redirectUrl"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 border px-2"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="mt-8 border-t border-gray-200 pt-5">
                      <div class="flex justify-end">
                        <span class="ml-3 inline-flex rounded-md shadow-sm">
                          <button
                            class="Polaris-Button Polaris-Button--primary"
                            type="submit"
                            @click="save"
                          >
                            <span class="Polaris-Button__Content">
                              <span class="Polaris-Button__Text">Save</span>
                            </span>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NotificationPreview from "../../../components/Common/NotificationPreview.vue";
// import Spinner from "vue-simple-spinner";

export default {
  name: "WelcomeNotificationConfig",
  mixins: [],
  data() {
    return {
      isLoading: false,
      notificationConfig: {},
      welcomeNotificationConfig: {},
      reminderConfig: {}
    };
  },
  components: {
    NotificationPreview

    // Spinner
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.$store.dispatch("getConfig");
    this.getAutomationConfig();
  },
  mounted() {},
  methods: {
    async getAutomationConfig() {
      this.isLoading = true;
      const configIndex = this.$route.params.index;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.notificationConfig = response.config;
        this.welcomeNotificationConfig = response.config.welcomeNotification;
        this.reminderConfig = this.welcomeNotificationConfig.configs[
          configIndex
        ];
        this.isLoading = false;
      });
    },
    save() {
      const configIndex = this.$route.params.index;
      this.welcomeNotificationConfig.configs[configIndex] = this.reminderConfig;
      const payload = {
        ...this.notificationConfig,
        welcomeNotification: this.welcomeNotificationConfig
      };
      this.$store
        .dispatch("updateAutomationConfig", {
          requestParams: {
            notificationConfig: payload
          }
        })
        .then(() => {
          this.$store.dispatch("showNotification", {
            text: "Settings Updated"
          });
        });
    },
    handleSubmit(event) {
      event.preventDefault();
    }
  }
};
</script>

<style lang="scss" scoped></style>
